import { EmployeeStatus } from '@seapoint/server/enums';
import { FormSelectField } from '../../../../../../design-system/form-select-field/form-select-field';
import { FormTextField } from '../../../../../../design-system/form-text-field/form-text-field';
import { Inline } from '../../../../../../design-system/inline/inline';
import { Select } from '../../../../../../design-system/select/select';
import { Stack } from '../../../../../../design-system/stack/stack';

export const PersonalInformation = () => {
  return (
    <Stack space={6} className="w-full">
      <Stack space={4} className="w-full">
        <h2 className="text-seapoint-gray-900 text-lg font-semibold">Personal Information</h2>

        <Inline space={4} className="w-full justify-between" wrap="nowrap" align="start">
          <div className="w-1/2">
            <FormTextField label="First Name" inputName="firstName" placeholder="Enter first name" />
          </div>
          <div className="w-1/2">
            <FormTextField label="Last Name" inputName="lastName" placeholder="Enter last name" />
          </div>
        </Inline>

        <FormSelectField label="Status" inputName="status" placeholder="Select status" triggerClassName="text-base">
          {Object.values(EmployeeStatus).map((status) => (
            <Select.Item key={status} value={status} className="py-3">
              <p className="text-base font-medium text-black">{status}</p>
            </Select.Item>
          ))}
        </FormSelectField>
      </Stack>
    </Stack>
  );
};
